"use client";
import ProfileNav from "@/components/parts/admin/profileNav";
import { Button } from "@/components/ui/button";
import useGetToken from "@/hooks/useGetToken";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import Logo from "./logo";

const LandingNavbar = () => {
  const { token, decode } = useGetToken();
  const pathname = usePathname();
  const params = useSearchParams();

  const tokenGoogle = params.get("token");

  const navItems = [
    { href: "/", label: "Beranda" },
    { href: "/aspiration", label: "Usulan" },
    { href: "/member", label: "Anggota DPRD" },
    { href: "/news", label: "Berita" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-lg">
      <div className="flex items-center justify-between py-5 px-4 md:px-12">
        <Link
          href="/"
          className="flex items-center gap-4 text-primary-700 text-base sm:text-xl font-semibold"
        >
          <Logo />
          <p className="">SIMRESES DPRD PALI</p>
        </Link>

        {/* Desktop Navigation */}
        <nav className="flex items-center gap-6">
          <ul className="hidden md:flex space-x-6">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className={`transition-colors duration-200 hover:text-primary-700 ${
                    pathname === item.href
                      ? "text-primary-700 font-semibold border-b-2 border-primary-700 pb-1"
                      : "text-gray-600"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          {!token && !tokenGoogle ? (
            <Link href={"/login"}>
              <Button className="bg-primary-700 rounded-full hover:bg-primary-800 transition-colors">
                Masuk
              </Button>
            </Link>
          ) : (
            <ProfileNav onlyDashboard={decode?.role !== "user"} />
          )}
        </nav>
      </div>
    </header>
  );
};

export default LandingNavbar;
